const MINUTE = 60_000;
const HOUR   = 60 * MINUTE;
const DAY    = 24 * HOUR;
const WEEK   = 7 * DAY;
const MONTH  = 30 * DAY;
const YEAR   = 365 * DAY;

function plural(n: number, unit: string): string {
  return `${n} ${unit}${n === 1 ? "" : "s"}`;
}

/** Format a delta in ms (negative = past, positive = future). */
function formatDelta(deltaMs: number): string {
  const abs = Math.abs(deltaMs);
  const sign = deltaMs < 0 ? -1 : 1; // -1 = past

  let value: number;
  let unit: string;

  if (abs < 60_000) {
    return "just now";
  } else if (abs < HOUR) {
    value = Math.round(abs / MINUTE);
    unit = "minute";
  } else if (abs < DAY) {
    value = Math.round(abs / HOUR);
    unit = "hour";
  } else if (abs < 4 * WEEK) {
    // Use days up to 4 weeks (28 days) — ensures "14 days" stays as days
    value = Math.round(abs / DAY);
    unit = "day";
  } else if (abs < 12 * MONTH) {
    // Weeks from 4w up to ~12 months — ensures "5 weeks" shows as weeks
    value = Math.round(abs / WEEK);
    unit = "week";
  } else {
    value = Math.round(abs / YEAR);
    unit = "year";
  }

  const label = plural(value, unit);
  return sign < 0 ? `${label} ago` : `in ${label}`;
}

export function formatRelative(iso: string | null, now: Date = new Date()): string {
  if (iso === null) return "never";
  const target = new Date(iso).getTime();
  const delta = target - now.getTime();
  return formatDelta(delta);
}

export function formatExpiry(iso: string | null, now: Date = new Date()): string {
  if (iso === null) return "never";
  const target = new Date(iso).getTime();
  if (target < now.getTime()) {
    const rel = formatRelative(iso, now);
    return `expired ${rel}`;
  }
  return formatRelative(iso, now);
}
